import React from 'react';
import {
  useEnvironment,
  useExperiments,
  useTranslation,
} from '@wix/yoshi-flow-editor';
import { ExperimentsConsts } from '../../../../consts/experiments';
import {
  SectionMessage,
  SectionMessageType,
} from '../SectionMessage/SectionMessage';
import Text from '../../Text/Text';
import { classes, st } from './BookForSomeoneElseBanner.st.css';
import { BookForSomeoneElseBannerDataHooks } from './dataHooks';

const BookForSomeoneElseBanner: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useEnvironment();
  const { experiments } = useExperiments();
  const isGuestCopy = experiments.enabled(
    ExperimentsConsts.CollectParticipantForm,
  );

  return (
    <SectionMessage
      type={SectionMessageType.Wired}
      withoutIcon
      className={st(classes.root, { isMobile })}
      notificationClassName={classes.notification}
      dataHook={BookForSomeoneElseBannerDataHooks.BANNER}
    >
      <Text tagName="p" className={classes.body}>
        {t(
          isGuestCopy
            ? 'bookings.form.bookForGuest.banner.body'
            : 'bookings.form.bookForSomeoneElse.banner.body',
        )}
      </Text>
    </SectionMessage>
  );
};

export default BookForSomeoneElseBanner;
